import styled, { css } from 'styled-components'

import {
    FlexCentered,
    AbsolutePositioning,
} from 'components/common/genericStyles'

const boxShadow = `box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.08), 0px 4px 12px -4px rgba(0, 0, 0, 0.08);`

export const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background: bisque;
    position: relative;
`

export const Wrapper = styled.div`
    ${AbsolutePositioning}
    width: 300px;
    height: 400px;

    transform: translate(-85%, -60%);

    background: #ffffff;

    border-radius: 8px;
    ${boxShadow}

    ${props => {
        const { visible } = props
        const display = visible ? 'block' : 'none'
        return css`
            display: ${display};
        `
    }}
`
export const Header = styled.div`
    position: relative;
    width: 100%;
    height: 12%;
    ${boxShadow}
    ${FlexCentered}
    cursor: default;
`

export const Footer = styled.div`
    width: 100%;
    height: 15%;
    padding: 10px 5px;
    ${FlexCentered}
    justify-content: space-around;
    border-top: 0.5px solid #0000001a;
`

export const Body = styled.div`
    width: 100%;
    height: 73%;

    .emoji-mart {
        width: 100% !important;
        height: 100%;
        overflow: hidden;
        border: none;
    }

    .emoji-mart-preview {
        display: none;
    }
`

export const Cross = styled.img`
    position: absolute;
    right: 15px;
    height: 12px;
    width: 12px;
    cursor: pointer;
    opacity: 0.5;
    transition: 0.3s opacity;
    :hover {
        opacity: 1;
    }
`

export const EmjoiBtn = styled.img`
    cursor: pointer;
`

export const InputGroup = styled.div`
    width: 88%;
    position: relative;
    .oh-rrc-input {
        padding-right: 30px;
        caret-color: #ef5c34;
    }
`

export const SendBtn = styled.button`
    background-image: url('assets/revamp/chat-send.svg');
    ${AbsolutePositioning}
    left: 85%;
    background-color: transparent;
    background-position: center;
    background-repeat: no-repeat;
    outline: none;
    border: none;
    width: 30px;
    cursor: pointer;
`
